import { Inbox } from '../icons.js';

/**
 * Раздел «Входящие» (3.4).
 *
 * Кнопка стоит в шапке любого спринта и видна всегда, а не появляется, когда
 * там что-то накопилось: раздел на видном месте — это требование (3.4.2), и
 * «пусто» сообщает не меньше, чем число. Счётчик считает незакрытые —
 * закрытая задача, записанная сюда на бегу, ничего не требует.
 *
 * На экране самих Входящих кнопки нет: вести на себя ей незачем, а отметка
 * «вы здесь» на ней только занимала место в тесной шапке телефона. Что это
 * Входящие, говорит заголовок. Прятать её решает `SprintHeader`.
 *
 * Отправка из Входящих в спринт делается тем же степпером, что и перенос между
 * спринтами (3.4.3), поэтому своей кнопки «отправить» здесь нет.
 */
export function InboxButton({
  count,
  onOpen,
}: {
  count: number;
  onOpen: () => void;
}): React.ReactElement {
  return (
    <button
      type="button"
      className="inbox"
      aria-label={`Входящие: ${String(count)} незакрытых`}
      onClick={onOpen}
    >
      <Inbox />
      <span className="tool__label">Входящие</span>
      {count > 0 && <span className="count">{count}</span>}
    </button>
  );
}
